import React, { useEffect } from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';

import { I18n } from '@aws-amplify/core';

import { OperatorEvaluated } from './OperatorEvaluated';
import { Organization } from './Organizations';
import { Workstations } from './Workstations';
import { WorkCenter } from './WorkCenter';
import { ReportName } from './ReportName';
import { Evaluator } from './Evaluator';
import { Companies } from './Companies';
import { Sectors } from './Sectors';
import { Cycles } from './Cycles';
import { Lines } from './Lines';
import { HeaderCol, StepDate, StepSubtitle, StepTitle, SubtitleCol } from './styles';

const FIELD_GUTTER = 32;

interface InformationsProps {
	disabled?: boolean;
	companyLocked?: boolean;
	onValueChange: (changed: boolean) => void;
}

export function Informations({
	disabled = false,
	companyLocked = false,
	onValueChange
}: Readonly<InformationsProps>): JSX.Element {
	const today = moment().format('L');

	useEffect(() => {
		onValueChange(false);
	}, []);

	return (
		<Col xs={24}>
			<Row justify="center">
				<HeaderCol xs={24}>
					<SubtitleCol xs={24}>
						<StepTitle>{I18n.get('General informations')}</StepTitle>
						<StepDate>{today}</StepDate>
					</SubtitleCol>
					<StepSubtitle>Insert below the informations for the cycle</StepSubtitle>
				</HeaderCol>
				<Col xs={24}>
					<Row gutter={[FIELD_GUTTER, 0]}>
						<ReportName onValueChange={onValueChange} />
					</Row>
					<Row gutter={[FIELD_GUTTER, 0]}>
						<Organization />
						<Companies disabled={disabled || companyLocked} />
						<Sectors disabled={disabled} />
						<Lines disabled={disabled} />
						<Workstations disabled={disabled} onValueChange={onValueChange} />
						<Cycles disabled={disabled} onValueChange={onValueChange} />
						<OperatorEvaluated onValueChange={onValueChange} />
						<WorkCenter onValueChange={onValueChange} />
						<Evaluator onValueChange={onValueChange} />
					</Row>
				</Col>
			</Row>
		</Col>
	);
}
